<div class="flex flex-col justify-between min-w-64 rounded-[20px] border border-[#E7EAF0] bg-white shadow-sm">
    <!-- Content -->
    <div class="flex flex-col gap-2 p-3">
        <div class="flex space-x-4">
            <!-- Avatar -->
            <ngx-skeleton-loader appearance="square" [theme]="{ width: '48px', height: '48px' }"></ngx-skeleton-loader>
            <div class="flex flex-col space-y-2 mt-2">
                <!-- Name -->
                <ngx-skeleton-loader class="w-28 h-4 rounded-md"></ngx-skeleton-loader>
                <!-- Member Count -->
                <ngx-skeleton-loader class="w-20 h-3 rounded-md"></ngx-skeleton-loader>
            </div>
        </div>
        <!-- Button -->
        <ngx-skeleton-loader
            class="w-full h-9"
            [theme]="{ height: '35px', borderRadius: '999px' }"></ngx-skeleton-loader>
    </div>
</div>
